(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lc-product-card"] && !Shopify.designMode) return;
  try {
    /* Carte produit : fondu des images, 2e image au survol, flèches, pastilles de couleur cliquables, ajout rapide. */
  (() => {
    const root = document.documentElement;
    root.classList.add('lc-pcard-js');

    /* Ton du texte (même méthode que card-tile-intel.js de Lancaster) : on lit la bande du bas de la photo ;
       texte blanc si elle est sombre (darkFraction > 0,18 ou luminance moyenne < 0,62), sinon noir.
       Une photo carrée (packshot, data-contain) reste en noir. */
    const toneCache = new Map();
    let toneCanvas = null;
    const stripLight = (bitmap) => {
      const h = Math.max(8, Math.round(40 * (bitmap.height / bitmap.width)));
      toneCanvas = toneCanvas || document.createElement('canvas');
      toneCanvas.width = 40;
      toneCanvas.height = h;
      const ctx = toneCanvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(bitmap, 0, 0, 40, h);
      const top = Math.round(h * 0.82);
      const data = ctx.getImageData(0, top, 40, h - top).data;
      let sum = 0, count = 0, dark = 0;
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 200) continue;
        const lum = (0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2]) / 255;
        sum += lum;
        if (lum < 0.6) dark++;
        count++;
      }
      const mean = count ? sum / count : 1;
      const darkFraction = count ? dark / count : 0;
      return darkFraction > 0.18 || mean < 0.62;
    };
    const toneOf = (src) => {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', '40');
      const key = url.href;
      if (!toneCache.has(key)) {
        toneCache.set(
          key,
          fetch(key)
            .then((r) => (r.ok ? r.blob() : Promise.reject(new Error('http'))))
            .then((blob) => createImageBitmap(blob))
            .then((bmp) => {
              try {
                return stripLight(bmp);
              } finally {
                bmp.close();
              }
            })
            .catch(() => false)
        );
      }
      return toneCache.get(key);
    };
    const updateCaption = (card) => {
      const active = card.querySelector('.card__media-slide.is-active');
      if (!active) return;
      if (active.dataset.contain === 'true' || !active.currentSrc) {
        card.dataset.caption = 'dark';
        return;
      }
      const src = active.currentSrc;
      toneOf(src).then((light) => {
        const now = card.querySelector('.card__media-slide.is-active');
        if (now === active && now.currentSrc === src) card.dataset.caption = light ? 'light' : 'dark';
      });
    };

    const markLoaded = (img) => {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('loaded');
        if (img.classList.contains('is-active') && img.closest) {
          const card = img.closest('[data-lc-card]');
          if (card) updateCaption(card);
        }
      }
    };
    const scan = (scope) => {
      scope.querySelectorAll('.card__media-slide').forEach(markLoaded);
    };
    document.addEventListener(
      'load',
      (event) => {
        const img = event.target;
        if (img && img.classList && img.classList.contains('card__media-slide')) markLoaded(img);
      },
      true
    );
    document.addEventListener(
      'error',
      (event) => {
        const img = event.target;
        if (img && img.classList && img.classList.contains('card__media-slide')) img.classList.add('loaded');
      },
      true
    );
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
    else scan(document);
    new MutationObserver((records) => {
      records.forEach((r) =>
        r.addedNodes.forEach((n) => {
          if (n.nodeType === 1) scan(n);
        })
      );
    }).observe(document.documentElement, { childList: true, subtree: true });

    const slidesOf = (card) => Array.from(card.querySelectorAll('.card__media-slide'));
    const loadDeferred = (card) => {
      card.querySelectorAll('img[data-deferred-src]').forEach((img) => {
        if (img.dataset.deferredSrcset) img.srcset = img.dataset.deferredSrcset;
        img.src = img.dataset.deferredSrc;
        img.removeAttribute('data-deferred-src');
        img.removeAttribute('data-deferred-srcset');
        img.loading = 'eager';
      });
    };
    const show = (card, index) => {
      const slides = slidesOf(card);
      if (!slides.length) return;
      const i = (index + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      updateCaption(card);
      card.dataset.index = String(i);
    };
    const current = (card) => Math.max(0, slidesOf(card).findIndex((s) => s.classList.contains('is-active')));
    const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

    /* Survol (souris, bureau) : la pastille survolée est selectionnee (la photo de la carte change, comme Lancaster),
       puis la 2e image de la carte s'affiche. */
    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse' || !isDesktop()) return;
      const swatch = event.target.closest && event.target.closest('color-swatch');
      if (swatch && !swatch.classList.contains('is-active')) {
        const owner = swatch.closest('[data-lc-card]');
        if (owner) selectSwatch(owner, swatch);
      }
      const card = event.target.closest && event.target.closest('[data-lc-card]');
      if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
      loadDeferred(card);
      if (slidesOf(card).length > 1 && current(card) === 0) show(card, 1);
    });
    document.addEventListener('pointerout', (event) => {
      if (event.pointerType !== 'mouse' || !isDesktop()) return;
      /* La souris quitte la rangee de pastilles : retour a la pastille selectionnee (ou la premiere). */
      const colors = event.target.closest && event.target.closest('[data-lc-colors]');
      if (colors && !(event.relatedTarget && colors.contains(event.relatedTarget))) {
        const owner = colors.closest('[data-lc-card]');
        const keep = owner && (owner.querySelector('color-swatch.swatch-selected') || owner.querySelector('color-swatch'));
        if (keep && !keep.classList.contains('is-active')) selectSwatch(owner, keep);
      }
      const card = event.target.closest && event.target.closest('[data-lc-card]');
      if (!card || (event.relatedTarget && card.contains(event.relatedTarget))) return;
      show(card, 0);
    });
    /* Mobile : les images différées se chargent dès le premier contact avec la galerie. */
    document.addEventListener(
      'touchstart',
      (event) => {
        const card = event.target.closest && event.target.closest('[data-lc-card]');
        if (card) loadDeferred(card);
      },
      { passive: true }
    );

    const setSlide = (card, slide, url, srcset, contain, alt) => {
      if (!url) return;
      slide.removeAttribute('data-deferred-src');
      slide.removeAttribute('data-deferred-srcset');
      slide.classList.remove('loaded');
      if (srcset) slide.srcset = srcset;
      slide.src = url;
      slide.dataset.contain = contain || 'false';
      if (alt != null) slide.alt = alt;
      markLoaded(slide);
    };

    /* Pastille : affiche la variante (image, prix, ajout rapide). Appelee au survol (souris sur bureau), au clic
       ou au toucher, et pour revenir a la pastille selectionnee quand la souris quitte la rangee. */
    const selectSwatch = (card, swatch) => {
      card.querySelectorAll('color-swatch').forEach((s) => s.classList.toggle('is-active', s === swatch));
      const slides = slidesOf(card);
      const gallery = card.querySelector('[data-lc-gallery]');
      const d = swatch.dataset;
      if (gallery && slides.length && d.mediaUrl) {
        const [main, second] = slides;
        setSlide(card, main, d.mediaUrl, d.mediaSrcset, d.mediaContain);
        if (second && d.hoverMediaUrl) setSlide(card, second, d.hoverMediaUrl, d.hoverMediaSrcset, d.hoverMediaContain);
        /* Les autres vues appartiennent a l'ancienne couleur : on les retire. */
        slides.slice(second && d.hoverMediaUrl ? 2 : 1).forEach((s) => s.remove());
        if (second && !d.hoverMediaUrl) second.remove();
        gallery.scrollTo && gallery.scrollTo({ left: 0 });
        show(card, 0);
        if (!card.querySelector('.card__media-slide:not(.is-active)')) {
          const controls = card.querySelector('.card-gallery-controls');
          if (controls) controls.hidden = true;
        }
      }
        const quick = card.querySelector('[data-lc-quick-add]');
        if (quick && quick.dataset.direct === 'true' && d.variantId) {
          quick.dataset.variantId = d.variantId;
          if (d.mediaUrl) quick.dataset.image = d.mediaUrl;
          if (d.price) quick.dataset.price = d.price;
          quick.closest('.card-information__quick-add').hidden = d.available === 'false';
        }
        const price = card.querySelector('[data-lc-price]');
        if (price && d.price) {
          const sale = d.compareAtPrice && d.compareAtPrice !== d.price;
          price.classList.toggle('price--on-sale', Boolean(sale));
          price.innerHTML = sale
            ? '<dl><div class="price__sale"><dd class="price__compare"><s class="price-item price-item--regular"></s></dd><dd><span class="price-item price-item--sale"></span></dd></div></dl>'
            : '<dl><div class="price__regular"><dd><span class="price-item price-item--regular"></span></dd></div></dl>';
          if (sale) {
            price.querySelector('s').textContent = d.compareAtPrice;
            price.querySelector('.price-item--sale').textContent = d.price;
          } else {
            price.querySelector('.price-item--regular').textContent = d.price;
          }
        }
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!target.closest) return;

      /* Pastille de couleur : la carte bascule sur la variante (image, lien, prix). */
      const swatch = target.closest('color-swatch');
      if (swatch) {
        const card = swatch.closest('[data-lc-card]');
        if (!card) return;
        event.preventDefault();
        event.stopPropagation();
        card.querySelectorAll('color-swatch').forEach((s) => s.classList.toggle('swatch-selected', s === swatch));
        const anchor = swatch.querySelector('a');
        const href = anchor ? anchor.getAttribute('href') : null;
        if (href) card.querySelectorAll('[data-card-product-link]').forEach((a) => a.setAttribute('href', href));
        selectSwatch(card, swatch);
        return;
      }

      /* Flèches de la galerie. */
      const arrow = target.closest('[data-lc-prev], [data-lc-next]');
      if (arrow) {
        const card = arrow.closest('[data-lc-card]');
        if (!card) return;
        event.preventDefault();
        event.stopPropagation();
        loadDeferred(card);
        show(card, current(card) + (arrow.hasAttribute('data-lc-next') ? 1 : -1));
        return;
      }

      /* Ajout rapide (produit à une seule variante). */
      const btn = target.closest('[data-lc-quick-add]');
      if (!btn) {
        /* Mobile, carrousels : la bande de texte capte le doigt (pour faire défiler le carrousel) ;
           un appui sur un espace vide de cette bande ouvre quand même la fiche produit. */
        const info = target.closest('.card-information');
        if (info && !isDesktop() && !target.closest('a, button, color-swatch')) {
          const link = info.closest('[data-lc-card]').querySelector('a[data-card-product-link][href]');
          if (link) window.location.href = link.getAttribute('href');
        }
        return;
      }
      if (btn.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      const cart = window.ValeraneCart;
      if (btn.dataset.direct !== 'true' || !cart || !cart.add) {
        window.location.href = btn.dataset.url;
        return;
      }
      btn.disabled = true;
      Promise.resolve(
        cart.add({
          id: Number(btn.dataset.variantId),
          quantity: 1,
          preview: {
            title: btn.dataset.title,
            variantTitle: '',
            image: btn.dataset.image,
            price: btn.dataset.price,
            compareAtPrice: btn.dataset.compare,
            url: btn.dataset.url,
          },
        })
      )
        .catch(() => {})
        .finally(() => {
          btn.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
